<template>
  <v-container :style="styleProps">
      <v-card class="mt-5" flat>
        <v-card-title> {{ pref_setup_label }} </v-card-title>
        <v-card-text>
          <ent-select
            :label="cat_label"
            :config="singleSelectSettings"
            :choices="cat_choices"
            v-model="cat_data"
          />
          <ent-input
            :label="pos_label"
            :config="basic_settings"
            v-model="pos_data"
          />
          <ent-input
            :label="code_label"
            :config="basic_settings"
            v-model="code_data"
          />
          <ent-select
            :label="languageLabel"
            :config="multiSelectSettings"
            :choices="languageItems"
            v-model="language_data"
          />
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-title> {{ name_label }} </v-card-title>
        <v-card-text>
          <ul>
            <li v-for="item in nameData" :key="item.id">
              <ent-input
                :label="item.id"
                :config="list_settings"
                v-model="item.data"
              />
            </li>
          </ul>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-title> {{ desc_label }} </v-card-title>
        <v-card-text>
          <ul>
            <li v-for="item in descData" :key="item.id">
              <ent-input
                :label="item.id"
                :config="list_settings"
                v-model="item.data"
              />
            </li>
          </ul>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-title> {{ pref_default_label }} </v-card-title>
        <v-card-text>
          <ent-select
            :config="singleSelectSettings"
            :choices="optionList"
            v-model="defaultChoice"
          />
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-title> {{ pref_options_label }} </v-card-title>
        <v-card-text>
          <ent-select
            :config="multiSelectSettings"
            :choices="optionList"
            v-model="optionChoices"
          />
        </v-card-text>
      </v-card>
    </v-container>
</template>
<script>
  import { sync } from "vuex-pathify";
  import metrcPrefUtils from "@/../../cortex/src/services/metrcpref.js";
  import loader from "@/../../library/mixins/loader.js";
  import phraseProc from "@/../../library/helper/phrase.js";
  import check from "@/../../library/helper/propertyCheck.js";
  import EntInput from "@/../../library/view/EntInput.vue";
  import EntSelect from "@/../../library/view/EntSelect.vue";

  export default {
    components: { EntInput, EntSelect },
    props: ["args", "finished"],
    mixins: [metrcPrefUtils, loader],
    data: () => ({
      // Setup
      basic_settings: { label: true },
      list_settings: { prelabel: true },
      multiSelectSettings: { multiple: true, label: true, chips: true },
      singleSelectSettings: { multiple: false, label: true, chips: false },

      // Labels
      name_label: "",
      cat_label: "",
      cat_pos_label: "",
      desc_label: "",
      pos_label: "",
      code_label: "",
      pref_setup_label: "",
      pref_default_label: "",
      pref_options_label: "",
      languageLabel: "",

      // Style Properties
      styleProps: null,

      // Choices for the different selectors
      cat_choices: [],
      optionList: ["ASAP", "Nightly", "Cortex Assist"],
      languageItems: ["en", "es"],

      // Multi-select data
      nameData: [],
      descData: [],
      language_data: [],
      optionChoices: [],

      // Single Value Data
      cat_data: null,
      cat_pos_data: null,
      pos_data: null,
      code_data: null,
      defaultChoice: null,
    }),
    computed: {
      dark: sync("misc/dark"),
      userlang: sync("misc/language"),
      phrases: sync("misc/phraseMap"),
    },
    watch: {
      language_data() {
        this.processLanguageUpdate();
        console.log(`Language check finished, checking status of save button`)
        this.enableSave();
      },
      cat_data() {
        console.log(`Watching selection of cat_data`)
        this.enableSave();
      },
      cat_pos_data() {
        this.enableSave();
      },
      pos_data() {
        this.enableSave();
      },
      code_data() {
        this.enableSave;
      },
      defaultChoice() {
        console.log(`Change in the default Choice`)
        this.enableSave();
      },
      nameData() {
        this.enableSave();
      },
      descData() {
        this.enableSave();
      },
      optionChoices() {
        this.enableSave();
      },
    },
    methods: {
      getHelp() {
        return false;
      },
      getPhrase(item) {
        return phraseProc.mapPhrase(item, this.phrases, this.userlang);
      },
      enableSave() {
        console.log(`Checking if save is enabled`)
        let cat = !check.isEmptyString(this.cat_data);
        let catpos = !check.isEmptyString(this.cat_pos_data);
        let pos = !check.isEmptyString(this.pos_data);
        let code = !check.isEmptyString(this.code_data);
        let defaultChoice = !check.isEmptyString(defaultChoice);
        let name = !check.isEmptyArray(this.nameData);
        let desc = !check.isEmptyArray(this.descData);
        let lang = !check.isEmptyArray(this.language_data);
        let options = !check.isEmptyArray(this.optionChoices);
        let enable =
          cat &&
          catpos &&
          pos &&
          code &&
          defaultChoice &&
          name &&
          desc &&
          lang &&
          options;
        if (enable) this.$emit("update:save_enable", true);
      },
      processLanguageUpdate() {
        for (const entry of this.language_data) {
          let nameEntry = this.nameData.find((x) => x.id === entry);
          let descEntry = this.descData.find((x) => x.id === entry);
          if (check.isUndefined(nameEntry))
            this.nameData.push({ id: entry, data: "" });
          if (check.isUndefined(descEntry))
            this.descData.push({ id: entry, data: "" });
        }
        console.log(`Array Empty = ${check.isEmptyArray(this.language_data)}`);
        if (check.isEmptyArray(this.language_data)) {
          this.nameData = [];
          this.descData = [];
        }
        console.log(`Check if language was removed`);
        let existingName = this.nameData;
        let existingDesc = this.descData;
        this.nameData = [];
        this.descData = [];
        console.log(`Processing change to exising Name`)
        for (const entry of existingName) {
          let foundLang = this.language_data.find((x) => x === entry.id);
          if (!check.isUndefined(foundLang)) this.nameData.push(entry);
        }
        console.log(`Processing change to existing description`)
        for (const entry of existingDesc) {
          let foundLang = this.language_data.find((x) => x === entry.id);
          if (!check.isUndefined(foundLang)) this.descData.push(entry);
        }
        console.log(`Finished language processing`)
      },
      async save() {
        console.log(`In the Save Function`);
        console.log(`Args = ${this.args}`);
        console.log(`Args: `, this.args);
        this.showLoader();
        let payload = {
          cat: this.cat_data,
          pos: this.pos_data,
          code: this.code_data,
          lang: this.language_data,
          name: this.nameData,
          desc: this.descData,
          defaultChoice: this.defaultChoice,
          options: this.optionChoices,
        };
        if (!this.args.hasOwnProperty("item") || check.isNull(this.args.item))
          await this.createRecord(payload);
        else {
          payload["item"] = this.args.item;
          await this.updateRecord(payload);
        }
        this.hideLoader();
        this.$emit("update:finished", true);
      },
    },
    async created() {
      console.log(`METRC Preferenced form Loaded`);
      console.log(`Args: `, this.args);

      // Create the labels in the user language
      this.desc_label = this.getPhrase("desc_label");
      this.name_label = this.getPhrase("name_label");
      this.cat_label = this.getPhrase("cat");
      this.cat_pos_label = this.getPhrase("catpos");
      this.pos_label = this.getPhrase("pos");
      this.code_label = this.getPhrase("mprefcode");
      this.pref_setup_label = this.getPhrase("pref_setup_label");
      this.pref_default_label = this.getPhrase("pref_default_label");
      this.pref_options_label = this.getPhrase("pref_options_label");
      this.languageLabel = this.getPhrase("langs");

      // Prepare the category choices
      let cat_choice_keys = [
        "loc_label",
        "immature_plants_label",
        "plants",
        "harvest",
        "packages",
        "metrc_transfers",
      ];
      for (const entry of cat_choice_keys) {
        let name = this.getPhrase(entry);
        this.cat_choices.push({ id: entry, name: name });
      }

      // Set the style properties for this instance
      if (this.args.hasOwnProperty("style")) this.styleProps = this.args.style;
      else this.styleProps = "width: 800px; vertical-align:top; height:100vh";

      if (this.args.hasOwnProperty("item") && !check.isNull(this.args.item)) {
        this.showLoader();
        // Get data from the existing record
        let existing = await this.getExisting(this.args.item);
        // Exit the loader once the axios calls are done
        this.cat_data = existing.cat;
        this.pos_data = existing.pos;
        this.code_data = existing.code;
        this.language_data = existing.lang;
        this.defaultChoice = existing.default;
        this.optionChoices = existing.options;
        for (const entry of this.language_data) {
          this.nameData.push({ id: entry, data: existing.namePhrase[entry] });
          this.descData.push({ id: entry, data: existing.descPhrase[entry] });
        }
        console.log(`Name Data = `, this.nameData);
        console.log(`Desc Data = `, this.descData);
        console.log(`Cat Data = `, this.cat_data);
        this.hideLoader();
      }
    },
  };
</script>
<style scoped>
  .compact-form {
    transform: scale(0.95);
    transform-origin: top;
  }
  .card-outter {
    padding-bottom: 50px;
  }
  .card-actions {
    position: absolute;
    bottom: 0;
  }
  .flexcard {
    display: flex;
    flex-direction: column;
  }
</style>
